import {Injectable} from '@angular/core';
import {Action, Store} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {QuestionnairesService} from './questionnaires.service';
import * as fromRoot from '../../../../state/app.state';
import {Observable, of} from "rxjs";
import * as Actions$ from "./questionnaires.actions";
import {
  AddSurveyResponseFailure,
  AddSurveyResponseRequest,
  AddSurveyResponseSuccess,
  AddSurveySendScheduleDataFailure,
  AddSurveySendScheduleDataRequest,
  AddSurveySendScheduleDataSuccess,
  CloseSurveyFailure,
  CloseSurveyRequest,
  CloseSurveySuccess,
  CreateDuplicateSurveyFailure,
  CreateDuplicateSurveyRequest,
  CreateDuplicateSurveySuccess,
  EditSurveyDataForEditScreenFailure,
  EditSurveyDataForEditScreenRequest,
  EditSurveyDataForEditScreenSuccess,
  EditSurveyDataForSendToFailure,
  EditSurveyDataForSendToRequest,
  EditSurveyDataForSendToSuccess,
  EditSurveyDataForSurveyConfigFailure,
  EditSurveyDataForSurveyConfigRequest,
  EditSurveyDataForSurveyConfigSuccess,
  EditSurveyResponseFailure,
  EditSurveyResponseRequest,
  EditSurveyResponseSuccess,
  EditSurveySendScheduleDataFailure,
  EditSurveySendScheduleDataRequest,
  EditSurveySendScheduleDataSuccess,
  FetchClinicsOptionsListFailure,
  FetchClinicsOptionsListRequest,
  FetchClinicsOptionsListSuccess,
  FetchEditSurveySummaryDetailsFailure,
  FetchEditSurveySummaryDetailsRequest,
  FetchEditSurveySummaryDetailsSuccess,
  FetchGenderOptionsListFailure,
  FetchGenderOptionsListRequest,
  FetchGenderOptionsListSuccess,
  FetchGroupsOptionsListFailure,
  FetchGroupsOptionsListRequest,
  FetchGroupsOptionsListSuccess,
  FetchGroupStatusOptionsListFailure,
  FetchGroupStatusOptionsListRequest,
  FetchGroupStatusOptionsListSuccess,
  FetchManageSurveyListFailure,
  FetchManageSurveyListRequest,
  FetchManageSurveyListSuccess,
  FetchMyQuestionnairesDetailsFailure,
  FetchMyQuestionnairesDetailsRequest,
  FetchMyQuestionnairesDetailsSuccess,
  FetchMyQuestionnairesListFailure,
  FetchMyQuestionnairesListRequest,
  FetchMyQuestionnairesListSuccess,
  FetchQuestionnaireDetailsForEditViewFailure,
  FetchQuestionnaireDetailsForEditViewRequest,
  FetchQuestionnaireDetailsForEditViewSuccess,
  FetchReviewSurveyDetailsFailure,
  FetchReviewSurveyDetailsRequest,
  FetchReviewSurveyDetailsSuccess,
  FetchRolesOptionsListFailure,
  FetchRolesOptionsListRequest,
  FetchRolesOptionsListSuccess,
  FetchScheduleAccordingToListForCreateSurveyFailure,
  FetchScheduleAccordingToListForCreateSurveyRequest,
  FetchScheduleAccordingToListForCreateSurveySuccess,
  FetchSessionListForCreateSurveyFailure,
  FetchSessionListForCreateSurveyRequest,
  FetchSessionListForCreateSurveySuccess,
  FetchSurveyDetailsByIdFailure,
  FetchSurveyDetailsByIdRequest,
  FetchSurveyDetailsByIdSuccess,
  FetchSurveyResponseForReviewAndEditForSuperAdminFailure,
  FetchSurveyResponseForReviewAndEditForSuperAdminRequest,
  FetchSurveyResponseForReviewAndEditForSuperAdminSuccess,
  FetchPendingSurveyCountRequest,
  FetchPendingSurveyCountSuccess,
  FetchPendingSurveyCountFailure
} from "./questionnaires.actions";
import {catchError, map, mergeMap, tap} from "rxjs/operators";
import {
  EditSurveyScheduleDetails,
  FetchQuestionnairesListModel
} from "../models/fetch-questionnaires-list.model";
import {QuestionnaireModel} from "../../../../models/questionnaire.model";
import {CommonService} from "../../../shared/services/common.service";
import {QuestionnaireConstant} from "../constants/questionnaire.enum";
import {Router} from "@angular/router";


@Injectable()
export class QuestionnairesEffects {

  fetchQuestionnairesList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(Actions$.FetchQuestionnairesListRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.questionnairesService.fetchQuestionnairesList().pipe(
          map((response: FetchQuestionnairesListModel['response']) => {
            const {data, message} = response;
            const questionnairesList: QuestionnaireModel[] = data;
            return Actions$.FetchQuestionnairesListSuccess({questionnairesList, message});
          }),
          catchError(() => {
            return of(Actions$.FetchQuestionnairesListFailure());
          }),
          tap((action: any) => {
            if (action.type === Actions$.FetchQuestionnairesListSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === Actions$.FetchQuestionnairesListFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );

  fetchMyQuestionnairesList$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchMyQuestionnairesListRequest), map((action) => {
    return action.payload;
  }), mergeMap(payload => {
    return this.questionnairesService.fetchMyQuestionnaires(payload)
      .pipe(map(response => {
          return FetchMyQuestionnairesListSuccess({payload: response.data})
        }), catchError(err => {
          return of(FetchMyQuestionnairesListFailure())
        }),
        tap((action: any) => {
          if (action.type === FetchMyQuestionnairesListSuccess.type) {
            // Code to execute on API Success Action dispatch
          } else if (action.type === FetchMyQuestionnairesListFailure.type) {
            // Code to execute on API Failure Action dispatch
          }
        }))
  })))

  fetchMyQuestionnairesDetails$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchMyQuestionnairesDetailsRequest), map((action: any) => {
    this.commonService.startLoading();
    return action.payload;
  }), mergeMap(payload => this.questionnairesService.fetchSurveyDetailsById({surveyId: payload.surveyId})
    .pipe(map(response => {
        return FetchMyQuestionnairesDetailsSuccess({payload: {details: response.data}})
      }), catchError(err => {
        return of(FetchMyQuestionnairesDetailsFailure())
      }),
      tap((action: any) => {
        if (action.type === FetchMyQuestionnairesDetailsSuccess.type) {
          // Code to execute on API Success Action dispatch
        } else if (action.type === FetchMyQuestionnairesDetailsFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
        this.commonService.stopLoading();
      })))))

  fetchReviewSurveyDetails$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchReviewSurveyDetailsRequest), map(actions => {
    this.commonService.startLoading();
    return actions.payload
  }), mergeMap(payload => this.questionnairesService.fetchSurveyReviewDetails({surveyId: payload.surveyId})
    .pipe(map(response => FetchReviewSurveyDetailsSuccess({payload: {surveyDetails: response.data}})), catchError(err => of(FetchReviewSurveyDetailsFailure())), tap((action: any) => {
      if (action.type === FetchReviewSurveyDetailsSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchReviewSurveyDetailsFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
      this.commonService.stopLoading();
    })))))

//fetch summary list
  fetchEditSurveySummaryDetails$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchEditSurveySummaryDetailsRequest), map(actions => actions.payload), mergeMap(payload => this.questionnairesService.fetchEditSurveySummaryDetails(payload)
    .pipe(map(response => FetchEditSurveySummaryDetailsSuccess({payload: {pending: response.data.pendingRespondents, respondents: response.data.respondents}})), catchError(err => of(FetchEditSurveySummaryDetailsFailure())), tap((action: any) => {
      if (action.type === FetchEditSurveySummaryDetailsSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchEditSurveySummaryDetailsFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    })))))

  fetchManageSurveyList$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchManageSurveyListRequest), map(actions => {
    return actions.payload
  }), mergeMap(payload => this.questionnairesService.fetchManageSurveyList(payload)
    .pipe(map(response => {
      return FetchManageSurveyListSuccess({payload: {...response.data}})
    }), catchError(err => of(FetchManageSurveyListFailure())), tap((action: any) => {
      if (action.type === FetchManageSurveyListSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchManageSurveyListFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    })))))

  //fetch session List
  fetchSessionListForCreateSurvey$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchSessionListForCreateSurveyRequest), map((action) => {
    this.commonService.startLoading();
    return action;
  }), mergeMap(payload => this.questionnairesService.fetchSessionListForCreateSurvey()
    .pipe(map(response => response.data.map(session => ({key: session.id, value: 'S' + session.id}))), map((sessionList: any) => {
      return FetchSessionListForCreateSurveySuccess({payload: {sessionList: sessionList}})
    }), catchError(err => of(FetchSessionListForCreateSurveyFailure())), tap((action: any) => {
      if (action.type === FetchSessionListForCreateSurveySuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchSessionListForCreateSurveyFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
      this.commonService.stopLoading();
    })))))

  //fetch schedule according to list
  fetchScheduleAccordingToListForCreateSurvey$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchScheduleAccordingToListForCreateSurveyRequest), map(actions => actions), mergeMap(payload => this.questionnairesService.fetchScheduleAccordingToList()
    .pipe(map((response: any) => {
      return FetchScheduleAccordingToListForCreateSurveySuccess({payload: {scheduleAccordingToList: response.data.list}})
    }), catchError(err => of(FetchScheduleAccordingToListForCreateSurveyFailure())), tap((action: any) => {
      if (action.type === FetchScheduleAccordingToListForCreateSurveySuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchScheduleAccordingToListForCreateSurveyFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    })))))

  //create survey send schedule data
  createSurveySendScheduleData$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(AddSurveySendScheduleDataRequest), map(actions => {
    this.commonService.startLoading();
    return actions.payload
  }), mergeMap(payload => this.questionnairesService.createSurveySendScheduleDetails({...payload.scheduleFormData, status: QuestionnaireConstant.draftStatus})
    .pipe(map(response => {
      return AddSurveySendScheduleDataSuccess({payload: response.data, message: response.message})
    }), catchError(err => of(AddSurveySendScheduleDataFailure())), tap((action: any) => {
      if (action.type === AddSurveySendScheduleDataSuccess.type) {
        this.commonService.notification(action.message, 'success');
        if (payload.navigate) {
          this.router.navigate([`/stanford-admin/questionnaires/create-questionnaire-form/${action.payload.id}`])
        } else {
          this.router.navigate([`/stanford-admin/questionnaires/edit/create-questionnaire-schedule/${action.payload.id}`])
        }
      } else if (action.type === AddSurveySendScheduleDataFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
      this.commonService.stopLoading();
    })))))

//edit schedule data
  editSurveySendScheduleData$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(EditSurveySendScheduleDataRequest), map(actions => {
    this.commonService.startLoading();
    return actions.payload
  }), mergeMap((payload: any) => {
    return this.questionnairesService.editSurveyDetails({surveyId: payload.surveyId, requestPayload: {...payload.scheduleFormData, status: QuestionnaireConstant.draftStatus}})
      .pipe(map((response: any) => {
        return EditSurveySendScheduleDataSuccess({payload: response.data, message: response.message})
      }), catchError(err => of(EditSurveySendScheduleDataFailure())), tap((action: any) => {
        if (action.type === EditSurveySendScheduleDataSuccess.type) {
          this.commonService.notification(action.message, 'success')
          if (payload.navigate) {
            if (payload.mode === QuestionnaireConstant.edit) {
              this.router.navigate([`/stanford-admin/questionnaires/edit/create-questionnaire-form/${action.payload.id}`])
            } else {
              this.router.navigate([`/stanford-admin/questionnaires/create-questionnaire-form/${action.payload.id}`])
            }
          }
        } else if (action.type === EditSurveySendScheduleDataFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
        this.commonService.stopLoading();
      }))
  })))

  //edit survey data
  editSurveySendConfigData$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(EditSurveyDataForSurveyConfigRequest), map(actions => {
    this.commonService.startLoading();
    return actions.payload
  }), mergeMap(payload => {
    const requestPayload: EditSurveyScheduleDetails['request'] = {
      requestPayload: {
        status: payload.status,
        config: payload.config
      },
      surveyId: payload.surveyId
    }
    return this.questionnairesService.editSurveyDetails({...requestPayload})
      .pipe(map(response => {
        return EditSurveyDataForSurveyConfigSuccess({payload: {}, message: response.message})
      }), catchError(err => of(EditSurveyDataForSurveyConfigFailure())), tap((action: any) => {
        if (action.type === EditSurveyDataForSurveyConfigSuccess.type) {
          this.commonService.notification(action.message, 'success');
          if (payload.navigate) {
            if (payload.mode === QuestionnaireConstant.edit) {
              this.router.navigate([`/stanford-admin/questionnaires/edit/create-questionnaire-send-to/${payload.surveyId}`])
            } else {
              this.router.navigate([`/stanford-admin/questionnaires/create-questionnaire-send-to/${payload.surveyId}`])
            }
          }
        } else if (action.type === EditSurveyDataForSurveyConfigFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
        this.commonService.stopLoading();
      }))
  })))


  //fetch roles
  fetchRolesListForSendToOptions$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchRolesOptionsListRequest), map(actions => actions), mergeMap(payload => this.questionnairesService.fetchRolesList()
    .pipe(map((response: any) => {
      return FetchRolesOptionsListSuccess({payload: {list: response.data.list}})
    }), catchError(err => of(FetchRolesOptionsListFailure())), tap((action: any) => {
      if (action.type === FetchRolesOptionsListSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchRolesOptionsListFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    })))));

  //fetch gender
  fetchGenderListForSendToOptions$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchGenderOptionsListRequest), map(actions => actions), mergeMap(payload => this.questionnairesService.fetchGenderList()
    .pipe(map((response: any) => {
      return FetchGenderOptionsListSuccess({payload: {list: response.data.list}})
    }), catchError(err => of(FetchGenderOptionsListFailure())), tap((action: any) => {
      if (action.type === FetchGenderOptionsListSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchGenderOptionsListFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    })))));

  //fetch clinics
  fetchClinicsListForSendToOptions$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchClinicsOptionsListRequest), map(actions => actions.payload), mergeMap(payload => this.questionnairesService.fetchClinicsList(payload)
    .pipe(map((response: any) => {
      return FetchClinicsOptionsListSuccess({
        payload: {
          ...response.data
        }
      })
    }), catchError(err => of(FetchClinicsOptionsListFailure())), tap((action: any) => {
      if (action.type === FetchClinicsOptionsListSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchClinicsOptionsListFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    })))));

  //fetch group status
  fetchGroupStatusListForSendToOptions$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchGroupStatusOptionsListRequest), map(actions => actions), mergeMap(payload => this.questionnairesService.fetchGroupStatusList()
    .pipe(map((response: any) => {
      return FetchGroupStatusOptionsListSuccess({payload: {list: response.data.list}})
    }), catchError(err => of(FetchGroupStatusOptionsListFailure())), tap((action: any) => {
      if (action.type === FetchGroupStatusOptionsListSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchGroupStatusOptionsListFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    })))));

  //edit survey Details for send to screen

  editSurveyDetailsForSendTo$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(EditSurveyDataForSendToRequest), map(actions => {
    this.commonService.startLoading();
    return actions.payload
  }), mergeMap(payload => {
    const requestPayload: EditSurveyScheduleDetails['request'] = {
      requestPayload: {
        status: payload.status,
        sendTo: {
          ...payload.sendTo
        },
        scheduleAccordingTo: payload.scheduleAccordingTo,
        activeFrom: payload.activeFrom,
        activeTo: payload.activeTo
      },
      surveyId: payload.surveyId
    }
    return this.questionnairesService.editSurveyDetails({...requestPayload})
      .pipe(map(response => {
        return EditSurveyDataForSendToSuccess({payload: {}, message: response.message})
      }), catchError(err => of(EditSurveyDataForSendToFailure())), tap((action: any) => {
        if (action.type === EditSurveyDataForSendToSuccess.type) {
          this.commonService.notification(action.message, 'success');
          if (payload.navigate) {
            this.router.navigate(['/stanford-admin/questionnaires/manage-questionnaires']);
          }
        } else if (action.type === EditSurveyDataForSendToFailure.type) {
          //Code to execute on API Failure Action dispatch
        }
        this.commonService.stopLoading();
      }))
  })))

  //fetch group list
  fetchGroupListForSendToScreen$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchGroupsOptionsListRequest), map(actions => actions.payload), mergeMap(payload => {
    return this.questionnairesService.fetchGroupList(payload)
    .pipe(map((response: any) => {
      return FetchGroupsOptionsListSuccess({
        payload: {
          ...response.data
        }
      })
    }), catchError(err => of(FetchGroupsOptionsListFailure())), tap((action: any) => {
      if (action.type === FetchGroupsOptionsListSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchGroupsOptionsListFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    }))})));

  //fetch survey Details

  fetchSurveyDetails$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchSurveyDetailsByIdRequest), map(actions => {
    // this.commonService.startLoading();
    return actions.payload
  }), mergeMap(payload => this.questionnairesService.fetchSurveyDetailsById({surveyId: payload.surveyId})
    .pipe(map((response: any) => {
      return FetchSurveyDetailsByIdSuccess({
        payload: {
          surveyDetails: response.data
        }
      })
    }), catchError(err => of(FetchSurveyDetailsByIdFailure())), tap((action: any) => {
      if (action.type === FetchSurveyDetailsByIdSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchSurveyDetailsByIdFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
      // this.commonService.stopLoading();
    })))));

  //create duplicate survey
  createDuplicateSurvey$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(CreateDuplicateSurveyRequest),
      map(action => {
        this.commonService.startLoading();
        return action.payload
      }),
      mergeMap(payload =>
        this.questionnairesService
          .fetchSurveyDetailsById({surveyId: payload.surveyId}).pipe(
          mergeMap((response: any) => {
            const updatedPayload = JSON.parse(JSON.stringify(response.data))
            updatedPayload.title = 'Copy of ' + response.data.title
            updatedPayload.status = 1;
            if (updatedPayload.scheduleAccordingTo === 2) {
              updatedPayload.activeFrom = new Date();
              const date = new Date()
              updatedPayload.activeTo = new Date(date.setFullYear(date.getFullYear() + 1))
            }
            delete updatedPayload.canTakeSurvey
            delete updatedPayload.createdAt
            delete updatedPayload.id
            delete updatedPayload.hasTakenSurvey
            delete updatedPayload.respondentsCount
            return this.questionnairesService.createSurveySendScheduleDetails(updatedPayload)
          }),
          map((surveyCreated: any) => CreateDuplicateSurveySuccess({
              payload: {
                surveyDetails: surveyCreated.data
              }
            })
          ),
          catchError(err => of(CreateDuplicateSurveyFailure())),
          tap((action: any) => {
              if (action.type === CreateDuplicateSurveySuccess.type) {
                // Code to execute on API Success Action dispatch
                this.router.navigate([`/stanford-admin/questionnaires/edit/create-questionnaire-schedule/${action.payload.surveyDetails.id}`])
              } else if (action.type === CreateDuplicateSurveyFailure.type) {
                // Code to execute on API Failure Action dispatch
              }
              this.commonService.stopLoading();
            }
          )
        )
      )
    )
  )

  //fetch details for edit screen details
  fetchSurveyDetailsForEditScreenDetails: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchQuestionnaireDetailsForEditViewRequest), map(actions => {
    this.commonService.startLoading();
    return actions.payload
  }), mergeMap(payload => this.questionnairesService.fetchSurveyDetailsById({surveyId: payload.surveyId})
    .pipe(map(response => FetchQuestionnaireDetailsForEditViewSuccess({payload: {surveyDetails: response.data}})), catchError(err => of(FetchQuestionnaireDetailsForEditViewFailure())), tap((action: any) => {
      if (action.type === FetchQuestionnaireDetailsForEditViewSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchQuestionnaireDetailsForEditViewFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
      this.commonService.stopLoading();
    })))));

  //edit survey details for edit screen
  editSurveyDetailsForEditScreenDetails: Observable<Action> = createEffect(() => this.actions.pipe(ofType(EditSurveyDataForEditScreenRequest), map(actions => {
    this.commonService.startLoading();
    return actions.payload
  }), mergeMap(payload => {
    const updatedPayload: any = {...payload.surveyDetails}
    delete updatedPayload.id
    return this.questionnairesService.editSurveyDetails({surveyId: payload.surveyDetails.id, requestPayload: updatedPayload})
      .pipe(map(response => EditSurveyDataForEditScreenSuccess({payload: {surveyDetails: response.data}, message: response.message})), catchError(err => of(EditSurveyDataForEditScreenFailure())), tap((action: any) => {
        if (action.type === EditSurveyDataForEditScreenSuccess.type) {
          this.commonService.notification(action.message, 'success');
          // Code to execute on API Success Action dispatch
        } else if (action.type === EditSurveyDataForEditScreenFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
        this.commonService.stopLoading();
      }))
  })));

  //close survey
  closeSurvey$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(CloseSurveyRequest), map(actions => {
    this.commonService.startLoading();
    return actions.payload
  }), mergeMap(payload => {
    const updatedPayload: any = {status: QuestionnaireConstant.closedStatus}
    delete updatedPayload.id
    return this.questionnairesService.editSurveyDetails({surveyId: payload.surveyId, requestPayload: updatedPayload})
      .pipe(map(response => CloseSurveySuccess()), catchError(err => of(CloseSurveyFailure())), tap((action: any) => {
        if (action.type === CloseSurveySuccess.type) {
          // Code to execute on API Success Action dispatch
          this.router.navigate(['/stanford-admin/questionnaires/manage-questionnaires'])
        } else if (action.type === CloseSurveyFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
        this.commonService.stopLoading();
      }))
  })));

  //add survey response
  addSurveyResponse$ = createEffect(() => this.actions.pipe(ofType(AddSurveyResponseRequest), map(actions => {
    this.commonService.startLoading();
    return actions.payload
  }), mergeMap(payload => {
    return this.questionnairesService.addSurveyResponse(payload)
      .pipe(map(response => {
        return AddSurveyResponseSuccess({message: response.message})
      }), catchError(err => of(AddSurveyResponseFailure())), tap((action: any) => {
        if (action.type === AddSurveyResponseSuccess.type) {
          this.commonService.notification(action.message, 'success');
          // Code to execute on API Success Action dispatch
          const urlPrefix = this.router.url.split('/')[1];
          this.router.navigate([`/${urlPrefix}/questionnaires/my-questionnaires`])
        } else if (action.type === AddSurveyResponseFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
        this.commonService.stopLoading();
      }))
  })))

  //fetch survey response details
  fetchSurveyResponseDetailsForReview$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchSurveyResponseForReviewAndEditForSuperAdminRequest), map(actions => {
    // this.commonService.startLoading();
    return actions.payload
  }), mergeMap(payload => this.questionnairesService.fetchSurveyReviewDetailsForReview({surveyId: payload.surveyId, userId: payload.userId})
    .pipe(map(response => FetchSurveyResponseForReviewAndEditForSuperAdminSuccess({payload: {surveyDetails: response.data}})), catchError(err => of(FetchSurveyResponseForReviewAndEditForSuperAdminFailure())), tap((action: any) => {
      if (action.type === FetchSurveyResponseForReviewAndEditForSuperAdminSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchSurveyResponseForReviewAndEditForSuperAdminFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
      // this.commonService.stopLoading();
    })))))

  //edit survey response
  editSurveyResponse$ = createEffect(() =>
    this.actions.pipe(
      ofType(EditSurveyResponseRequest),
      map(actions => {
        this.commonService.startLoading();
        return actions.payload
      }),
      mergeMap(payload =>
        this.questionnairesService.addSurveyResponse(payload).pipe(
          map(response => {
            const {message} = response;
            return EditSurveyResponseSuccess({message});
          }),
          catchError(err => {
            return of(EditSurveyResponseFailure({
              payload: {
                surveyId: payload.surveyId,
                forUserId: payload.forUserId
              }
            }))
          }),
          tap((action: any) => {
            if (action.type === EditSurveyResponseSuccess.type) {
              this.questionnairesService.updateSurveyReviewMode.next('view');
              this.commonService.notification(action.message, 'success');
              // Code to execute on API Success Action dispatch
            } else if (action.type === EditSurveyResponseFailure.type) {
              this.store.dispatch(FetchSurveyResponseForReviewAndEditForSuperAdminRequest({
                payload: {
                  surveyId: action.payload.surveyId,
                  userId: action.payload.forUserId
                }
              }))
              // Code to execute on API Failure Action dispatch
            }
            this.commonService.stopLoading();
          }))
      )))

  fetchPendingSurveyCount$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchPendingSurveyCountRequest),
      mergeMap(() =>
        this.questionnairesService.fetchPendingSurveyCount().pipe(
          map(response => FetchPendingSurveyCountSuccess({payload: {count: response.data.count}})),
          catchError(err => of(FetchPendingSurveyCountFailure()))
        )
      )))

  constructor(
    private store: Store<fromRoot.State>,
    private questionnairesService: QuestionnairesService,
    private actions: Actions,
    private commonService: CommonService,
    private router: Router
  ) {
  }
}
